import type { Produto } from '../db/tipos'

// Categoria/Linha em LISTA (spec 2026-09-30, decisao 6): so o que ela ja usa.
// "biscoitos" e "Biscoitos " sao a mesma coisa -- fica a grafia mais usada.
// O valor do produto aberto sempre entra: nunca some nem se reescreve sozinho.
const chave = (s: string) => s.trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export function valoresUsados(
  produtos: Pick<Produto, 'categoria' | 'linha' | 'apagado_em'>[], campo: 'categoria' | 'linha', atual: string,
): string[] {
  const grupos = new Map<string, Map<string, number>>()
  for (const p of produtos) {
    const v = p[campo]?.trim()
    if (!v || p.apagado_em !== null) continue
    const g = grupos.get(chave(v)) ?? new Map<string, number>()
    g.set(v, (g.get(v) ?? 0) + 1)
    grupos.set(chave(v), g)
  }
  const escolhidos = new Map<string, string>()
  for (const [k, g] of grupos) escolhidos.set(k, [...g].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0][0])
  if (atual.trim() !== '') escolhidos.set(chave(atual), atual)
  return [...escolhidos.values()].sort((a, b) => a.localeCompare(b, 'pt-BR'))
}
